import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaChevronDown, FaChevronRight, FaUserCircle } from "react-icons/fa";
import { useAuth } from "../../hooks/useAuth";
import { getMenuByUserType } from "./menuConfig";
import styles from "./Sidebar.module.css";

const Sidebar = ({ isOpen, onClose }) => {
  const { user } = useAuth();
  const location = useLocation();
  const currentYear = new Date().getFullYear();
  const [expandedMenus, setExpandedMenus] = useState({});

  // Get menu items based on user type
  const userType = user?.user_type || "product_admin";
  const menuItems = getMenuByUserType(userType);

  const toggleMenu = (menuId) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuId]: !prev[menuId],
    }));
  };

  const isMenuActive = (menu) => {
    if (menu.path) {
      return location.pathname === menu.path;
    }
    if (menu.children) {
      return menu.children.some((child) => location.pathname === child.path);
    }
    return false;
  };

  const isChildActive = (path) => {
    return location.pathname === path;
  };

  const handleLinkClick = () => {
    // Close sidebar on mobile after clicking a link
    if (window.innerWidth <= 992) {
      onClose();
    }
  };

  return (
    <>
      {/* Overlay for mobile */}
      <div
        className={`${styles.overlay} ${isOpen ? styles.overlayVisible : ""}`}
        onClick={onClose}
      />

      <aside
        className={`${styles.sidebar} ${isOpen ? styles.sidebarOpen : ""}`}
      >
        {/* User Profile Section */}
        <div className={styles.userProfile}>
          <div className={styles.userAvatar}>
            {user?.avatar ? (
              <img src={user.avatar} alt={user.name} />
            ) : (
              <FaUserCircle className={styles.defaultAvatar} />
            )}
          </div>
          <div className={styles.userInfo}>
            <span className={styles.userNameText}>
              {user?.name || "iFillip"}
            </span>
            <FaChevronDown className={styles.userDropdownIcon} />
          </div>
        </div>

        {/* Navigation Section */}
        <nav className={styles.navigation}>
          <div className={styles.navSection}>
            <span className={styles.navSectionTitle}>MAIN NAVIGATION</span>
          </div>

          <ul className={styles.menuList}>
            {menuItems.map((menu) => (
              <li key={menu.id} className={styles.menuItem}>
                {menu.children ? (
                  // Menu with children (expandable)
                  <>
                    <button
                      className={`${styles.menuButton} ${
                        isMenuActive(menu) ? styles.menuButtonActive : ""
                      }`}
                      onClick={() => toggleMenu(menu.id)}
                    >
                      <span className={styles.menuIcon}>
                        {menu.icon && <menu.icon />}
                      </span>
                      <span className={styles.menuTitle}>{menu.title}</span>
                      <span className={styles.menuArrow}>
                        {expandedMenus[menu.id] ? (
                          <FaChevronDown />
                        ) : (
                          <FaChevronRight />
                        )}
                      </span>
                    </button>

                    {/* Submenu */}
                    <ul
                      className={`${styles.submenu} ${
                        expandedMenus[menu.id] ? styles.submenuOpen : ""
                      }`}
                    >
                      {menu.children.map((child) => (
                        <li key={child.id} className={styles.submenuItem}>
                          <NavLink
                            to={child.path}
                            className={`${styles.submenuLink} ${
                              isChildActive(child.path)
                                ? styles.submenuLinkActive
                                : ""
                            }`}
                            onClick={handleLinkClick}
                          >
                            {child.title}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  // Single menu item (no children)
                  <NavLink
                    to={menu.path}
                    className={`${styles.menuLink} ${
                      isMenuActive(menu) ? styles.menuLinkActive : ""
                    }`}
                    onClick={handleLinkClick}
                  >
                    <span className={styles.menuIcon}>
                      {menu.icon && <menu.icon />}
                    </span>
                    <span className={styles.menuTitle}>{menu.title}</span>
                  </NavLink>
                )}
              </li>
            ))}
          </ul>
        </nav>

        {/* Footer */}
        <div className={styles.sidebarFooter}>
          <span>© 2018 - {currentYear} </span>
          <span className={styles.footerBrand}>IFILLIP - ADMIN</span>
          <span>.</span>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
